/**
 * postStreak.js — utility do śledzenia streak'u publikacji postów.
 *
 * Storage: localStorage `apisai_post_dates` = ['2026-02-10', '2026-02-09', ...]
 *
 * recordPostPublish() — dodaje dzisiejszą datę i zwraca obiekt {streak, isNew, total}
 *   - streak: liczba kolejnych dni z postem licząc wstecz od dzisiaj
 *   - isNew: true jeśli dzisiaj jest pierwszy post (data dodana właśnie)
 *   - total: łączna liczba dni z postami w historii
 *
 * getStreak() — zwraca aktualny streak bez dodawania.
 */

const STORAGE_KEY = 'apisai_post_dates';
const MAX_HISTORY = 90; // przechowuj max 90 dni historii

function todayStr() {
  return new Date().toISOString().slice(0, 10);
}

function loadDates() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function saveDates(dates) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(dates));
  } catch {}
}

function computeStreak(dates) {
  if (!dates.length) return 0;
  const set = new Set(dates);
  let count = 0;
  const cursor = new Date();
  // Walk backwards day by day
  for (let i = 0; i < MAX_HISTORY; i++) {
    const key = cursor.toISOString().slice(0, 10);
    if (set.has(key)) {
      count++;
      cursor.setDate(cursor.getDate() - 1);
    } else {
      break;
    }
  }
  return count;
}

export function getStreak() {
  return computeStreak(loadDates());
}

export function recordPostPublish() {
  const dates = loadDates();
  const today = todayStr();
  const isNew = !dates.includes(today);
  let updated = dates;
  if (isNew) {
    updated = Array.from(new Set([today, ...dates])).slice(0, MAX_HISTORY);
    saveDates(updated);
  }
  return {
    streak: computeStreak(updated),
    isNew,
    total: updated.length,
  };
}
